<form [formGroup]="SBtnForm" autocomplete="off">
  <div class="form-group">
    <div class="cDefault">
      <h5>Show action button?</h5>
      <mat-radio-group formControlName="ShowActionButton">
        <mat-radio-button value="Y">Yes</mat-radio-button>
        <mat-radio-button value="N">No</mat-radio-button>
      </mat-radio-group>
    </div>
    <div *ngIf="btnForm.ShowActionButton.value === 'Y'">
      <div class="cManikSmartButtonLayoutWrapper">
        <div class="cManikSmartButtonWrapper1">
          <div class="cManikSmartButtonWrapper2">
            <input class="cManikSmartButtonActionInput" type="checkbox" id="head1" name="head1" value="#ff006a"> <label
              class="cManikActionButton1" for="head1">show action button</label>
            <div class="cManikSmartButtonWrapSection">
              <div class="row">
                <div class="col-lg-6">
                  <div class="cManikSmartButtonBehaviour">behaviour</div>
                  <div class="cManikSmartButtonNavigate"><input type="text" placeholder="button text" /></div>
                  <select class="form-control cManikSmartButtonSelectInputType" id="sel1">
                    <option>type</option>
                    <option>2</option>
                    <option>3</option>
                    <option>4</option>
                  </select>
                  <div class="cManikSmartButtonNavigate"><input type="text" placeholder="navigate url" /></div>

                  <div class="cManikSmartColorPicker">
                    <input class="ver01" type="color" id="head" name="head" value="#ff006a">
                    <label class="cManikSmartBgColor" for="head">text color</label>
                  </div>

                  <div class="cManikSmartColorPicker">
                    <input class="ver01" type="color" id="head" name="head" value="#ff006a">
                    <label class="cManikSmartBgColor" for="head">background color</label>
                  </div>

                  <div class="cManikSmartColorPicker">
                    <input class="ver01" type="color" id="head" name="head" value="#ff006a">
                    <label class="cManikSmartBgColor" for="head">border color</label>
                  </div>

                  <select class="form-control cManikSmartButtonSelectInputType" id="sel1">
                    <option>select border width</option>
                    <option>1px</option>
                    <option>2px</option>
                    <option>3px</option>
                    <option>4px</option>
                    <option>5px</option>
                    <option>6px</option>

                  </select>

                  <select class="form-control cManikSmartButtonSelectInputType" id="sel1">
                    <option>select button shape</option>
                    <option>sequare</option>
                    <option>rounded</option>

                  </select>

                  <div class="cManikSmartSelectIcon">
                    <input class="" type="checkbox" id="head1" name="head1" value="#ff006a"> <label
                      class="cManikActionButton1" for="head1">include icon ?</label>
                  </div>

                </div>
                <div class="col-lg-6">
                  <div class="cManikSmartButtonBehaviour">advance</div>
                  <select class="form-control cManikSmartDropdwonSelector" id="sel1">
                    <option>select button size</option>
                    <option>auto</option>
                    <option>medium</option>
                    <option>large</option>
                    <option>custom</option>
                  </select>

                  <select class="form-control cManikSmartDropdwonSelector" id="sel1">
                    <option>select font size</option>
                    <option>10px</option>
                    <option>12px</option>
                    <option>13px</option>
                    <option>14px</option>
                  </select>

                  <select class="form-control cManikSmartDropdwonSelector" id="sel1">
                    <option>select font family</option>
                    <option>arial</option>
                    <option>open sans</option>
                    <option>arial</option>
                    <option>open-quote</option>
                  </select>

                </div>
              </div>
              <div class="cManikSmartSaveButton">
                <button class="cManikSmartWrapSaveButton">save</button>
              </div>
            </div>
          </div>
        </div>
        <div class="cManikFinishButton">
          <div class="cManikSmartButtonBehaviour">your button will look like this.</div>
          <div class="cManikSmartSaveButton">
            <button class="cManikSmartWrapSendButton">send</button>
          </div>
        </div>
        <div class="cManikSmartSetButton">
          <div class="cManikSmartButtonBehaviour">your button will look like this.</div>
          <div class="cManikSmartSaveButton">
            <button class="cManikSmartWrapSendButton"><span class="cManikSmartFaSelector"><i class="fa fa-check"
                  aria-hidden="true"></i>
              </span>send</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>

<!-- <form [formGroup]="SBtnForm" autocomplete="off">
  <div class="form-group">
    <div class="cDefault">
      <h5>Show action button?</h5>
      <mat-radio-group formControlName="ShowActionButton">
        <mat-radio-button value="Y">Yes</mat-radio-button>
        <mat-radio-button value="N">No</mat-radio-button>
      </mat-radio-group>
    </div>
    <div *ngIf="btnForm.ShowActionButton.value === 'Y'">
      <div class="cDefault">
        <h5>ActionText <span>*</span></h5>
        <input formControlName="ActionText" autocomplete="new-password" placeholder="ActionText" type="text">
      </div>
      <div class="cDefault">
        <h5>NavigateURL <span>*</span></h5>
        <input formControlName="NavigateURL" placeholder="NavigateURL" autocomplete="new-password" type="text">
      </div>
      <div class="cDefault">
        <h5>IconText</h5>
        <input type="text" autocomplete="new-password" formControlName="IconText">
      </div>
      <div class="cDefault">
        <h5>BGColor</h5>
        <input type="color" formControlName="BGColor">
      </div>
      <div class="cDefault">
        <h5>TextColor</h5>
        <input type="color" formControlName="TextColor">
      </div>
      <div class="cMatdd_main">
        <h5>ButtonLayoutID</h5>
        <mat-select placeholder="Choose Layout" formControlName="ButtonLayoutID"></mat-select>
      </div>
    </div>
  </div>
</form> -->